import { LoadingSpinner } from "@components/layouts/LoadingSpinner";
import { selectCurrentToken } from "@states/auth/auth.slice";
import { Suspense } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import RootPage from "./RootPage";
import Cookies from "js-cookie";
import NotFoundPage from "./NotFoundPage";
import NoPermission from "./NoPermission";

const RequireAuth = () => {
  const token = Cookies.get("token");
  const storedToken = localStorage.getItem("dms-access-token");
  const location = useLocation();
  return token ? (
    // return true ? (
    <Suspense fallback={<LoadingSpinner />}>
      <RootPage />
    </Suspense>
  ) : (
    // (window.location.href = "https://sso.edkamm.com/login")
    // <Navigate to="/no-permission" />
    <NoPermission />
  );
};

export default RequireAuth;
